
<section class='boss-golf' fxLayout='row' fxLayoutAlign='start stretch'>
  <div fxFlex='65'>
    <div class='boss-lady'>
      <img src='/assets/images/woman-golfer.jpg' style='width:100%'>
    </div>
  </div>
  <div fxFlex='35' fxLayout='column' fxLayoutAlign='center stretch'>
    <div class='boss-text'>
      Are you a boss on the course?
    </div>
    <div class='boss-sub-text'>
      Check out our all-in-one digital golf league management desktop and mobile app.
    </div>
    <div class='center' style='padding-top:30px;' fxLayout='column' fxLayoutAlign='center stretch'>
      <div>
        <input placeholder="First Name" [(ngModel)]='fName' type='text' />
      </div>
      <div>
        <input placeholder="Last Name" [(ngModel)]='lName' type='text' />
      </div>
      <div>
        <input placeholder="E-mail" [(ngModel)]='email' type='text' />
        <input placeholder="Phone (10-digit US)" [(ngModel)]='phone' type='tel' />
        <div *ngIf='registerError' class='error'>{{ registerError }}</div>
      </div>
      <div>
        <button mat-raised-button class='orange-button small' (click)='register()'>Register Now!</button>
      </div>
    </div>
  </div>
</section>
<div style='position: relative; z-index: 12;margin-top: 3px;'>
<s18-kick-putt></s18-kick-putt>
</div>
<div style='margin-top:80px'>
<s18-try-it-free [showHeader]='false'></s18-try-it-free>
</div>
